import React, { Component } from 'react';
import { Icon, Button } from '../../../../../ui-kit';
import { notify } from '../../../../Notifications';
import { requestAccessQuery } from '../api/requestAccess';
import { GENERIC_ERROR_MSG } from '../../../constants/genericError';
import HelpCenterButton from '../../../../../common/components/HelpCenterButton';
import '../styles/_request-access.scss';











export default class RequestAccess extends Component {
  constructor() {
    super();

    this.state = {
      requesting: false,
      requested: false
    };
  }

  handleRequestAccess = async () => {
    const { apiClient, ownerId } = this.props;

    this.setState({ requesting: true });

    try {
      const { errors = [] } = await apiClient.query({
        query: requestAccessQuery,
        context: { module: 'users' },
        variables: {
          input: {
            ownerId,
            url: window.location.href
          }
        }
      });

      if (errors.length) {
        notify({ type: 'error', content: GENERIC_ERROR_MSG });

        return void this.setState({ requesting: false });
      }

      this.setState({ requested: true, requesting: false });
    } catch (err) {
      notify({ type: 'error', content: GENERIC_ERROR_MSG });

      this.setState({ requesting: false });
    }
  };

  render() {
    const { requesting, requested } = this.state;

    return (
      <div className="request-access">
        <div className="request-access__inner">
          <Icon className="request-access__icon" name="padlock" color="regent" />
          <div className="request-access__text">
            <p className="request-access__header">
              {'Hmm.. you don\'t seem to have access to this page.'}
            </p>
            <p className="request-access__suggest">You can request access from the page owner</p>
            <Button
              busy={requesting}
              onClick={this.handleRequestAccess}
              disabled={requested}>

              {
              requested ?

              <div className="request-access__requested">
                      <Icon name="success" color="white" size={20} />
                      Access Requested
                    </div> :

              'Request Access'}

            </Button>
          </div>
        </div>
        <p className="request-access__assist">
          If the problem persists, contact your dedicated Account Manager or visit our
          {' '}
          <HelpCenterButton />
          {' '}
          for more information.
        </p>
      </div>);

  }
}